import React, { useState, useEffect } from "react";

function BillingSummary() {
  const [billAmount, setBillAmount] = useState(0);

  useEffect(() => {
    // This would typically fetch from an API in a real app
    // For demo purposes, we'll use a mock value stored in localStorage
    // or generate a random amount for demonstration
    const storedAmount = localStorage.getItem("billAmount");

    if (storedAmount) {
      setBillAmount(parseFloat(storedAmount));
    } else {
      // For demo: generate a random amount between $5-$50 with 2 decimal places
      const randomAmount = (Math.random() * 45 + 5).toFixed(2);
      localStorage.setItem("billAmount", randomAmount);
      setBillAmount(parseFloat(randomAmount));
    }
  }, []);

  return (
    <div className="flex justify-end items-center py-2 px-4 text-sm text-gray-700 border-t border-gray-200">
      <span className="font-medium mr-2">Bill amount:</span>
      <span className="font-bold">${billAmount.toFixed(2)}</span>
    </div>
  );
}

export default BillingSummary;
